import React from 'react'
import ShopProducts from './ShopProduct'
import './Shop.css'
import {AiOutlineShoppingCart, AiOutlineCloseCircle} from 'react-icons/ai'
import {AiOutlineHeart} from 'react-icons/ai'
import {BsEye} from 'react-icons/bs'
import { useAuth0 } from "@auth0/auth0-react"
import { Link } from 'react-router-dom' 



const Shop = ({shopProducts, setShopProducts, detail, view, close, setClose, addtocart}) => {
    const { loginWithRedirect,isAuthenticated } = useAuth0();
 
    const allProducts = ()=>{
        setShopProducts(ShopProducts);
    }
 
  return (
    <>
    {
        close?
        <div className='product_detail'>
        <div className='container'>
            <button onClick={()=> setClose(false)} className='closebtn'><AiOutlineCloseCircle/></button>
            {
                detail.map((curElm)=>{
                  return(
                    <div className='productbox'>
                        <div className='imgbox'>
                            <img src={curElm.Img} alt={curElm.Cat}/>

                        </div>
                        <div className='detail'>
                            <h4>{curElm.Cat}</h4>
                            <p>More than just a brand</p>
                            <h3>{curElm.Price}</h3>
                            <button>Add To Cart</button>

                        </div>

                    </div>
                  )
                })
            }

        </div>

    </div> : null
    }
    
   
    <div className='shop'>
        <h3># Shop</h3>
        <p><Link to='/' className='no-underline'>Home</Link> .Shop</p>
        <div className='container'>
            <div className='products'>
                <div className='categories'>
                    <ul>
                        <li onClick={()=> allProducts()}>All</li>
                    </ul>
                 <Link to='/shop/shop-by-categories' className='no-underline'><h3>Categories</h3></Link>
                </div>
                <div className='product_box'>
                    {
                        shopProducts.map((curElm)=>{
                             return(
                                 <div className='box' key={curElm.id}>
                                     <div className='img_box'>
                                         <img src={curElm.Img} alt={curElm.Cat} />
                                         <div className='icons'>
                                            {
                                                isAuthenticated ?
                                                <li onClick={() => addtocart(curElm)}><AiOutlineShoppingCart/></li>
                                                    :
                                                <li onClick={() => loginWithRedirect()}><AiOutlineShoppingCart/></li>
                                            }
                                             <ul>
                                                 
                                                 <li><AiOutlineHeart/></li>
                                                 <li onClick={()=>view(curElm)}><BsEye/></li>       
                                             </ul>          
                                         </div>
                                     </div>
                                     <div className='detail'>
                                         <p>{curElm.Cat}</p>
                                         <h3>{curElm.Price}</h3>
                                     </div>
                                 </div>
                               )
                            })
                     }
                </div>
                
            </div>
        </div>

    </div>
    </>
  )
}

export default Shop